// @ts-nocheck
import { currencyFormatter } from "@sia/style-guide";
// this will generate the Barchart option props

function tooltipNumberFormater(value, label, precision) {
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number") {
    let temp = value.toFixed(precision);
    temp = Number.parseFloat(temp);
    if (precision === 1) {
      return temp + " %";
    }
    return "CHF " + currencyFormatter.formatAlternate(temp);
  }
}

export function generateBarchartOptions(translate, isMobile, isVertical) {
  const ownValueColorCode = "#e41a11";
  const averageColorCode = "#000000";

  let options = {
    color: {
      scale: {
        [translate("benchmarking.evaluations.salary.chart-legend.my-office")]: ownValueColorCode,
        [translate("benchmarking.evaluations.salary.chart-legend.average")]: averageColorCode,
      },
    },
    legend: {
      order: [translate("benchmarking.evaluations.salary.chart-legend.average"), translate("benchmarking.evaluations.salary.chart-legend.my-office")],
    },
    axes: {
      left: {
        truncation: {
          type: "end_line",
          threshold: isMobile ? 10 : 25,
          numCharacter: isMobile ? 10 : 25,
        },
      },
      bottom:{
        ticks: {
          formatter: (value) => value + " %",
        },
      }
    },
    tooltip: {
      valueFormatter: (value, label) => tooltipNumberFormater(value, label, isVertical ? 2 : 1),
    },
  };

  if (isVertical) {
    options.axes = {
      // @ts-ignore
      left: {
        mapsTo: "value",
        scaleType: "linear",
      },
      bottom: {
        scaleType: "labels",
        mapsTo: "key",
        truncation: {
          threshold: isMobile ? 10 : 25,
          numCharacter: isMobile ? 10 : 25,
        },
      },
    };
  }

  return options;
}

export function generateHeaderRows(translate, headerRowGenerator, hasOwnValue) {
  let extraClasses = !hasOwnValue ? " without-own-value" : "";
  if (headerRowGenerator) {
    return headerRowGenerator();
  }
  let headerObjects = [
    { key: "key-figure", className: "bold-header no-border left-align" },
    { key: "average", className: "bold-header no-border".concat(extraClasses) },
  ];
  if (hasOwnValue) {
    headerObjects.push({ key: "ownValue", className: "bold-header no-border" }, { key: "deviation", className: "bold-header no-border" });
  }
  let headerRows = [];
  let firstHeaderRow = {
    className: "main-header",
    headers: headerObjects.map((object, index) => {
      let baseObject = {
        id: object.key,
        key: object.key,
        colSpan: 1,
        name: translate(`benchmarking.data-table.header-row.${object.key}`),
        className: object.className,
      };
      return baseObject;
    }),
  };
  headerRows.push(firstHeaderRow);

  return headerRows;
}
